import icons from "./styleguide/icons";
import colors from "./styleguide/colors";
const gstyles = {
  icons,
};
export { colors };
export default gstyles;
